module.exports = __webpack_public_path__ + "img/qufu-name-1.f891bceb.png";